// extracted by mini-css-extract-plugin
export default {"preserved-frame":"canvas-history-serialization_preserved-frame__VTG8S"};